import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

@Injectable()
export class CustomFieldService {

    public response: any = { data: {}};
    private m_url=sessionStorage.getItem('$wui_url')+"app_locobook/config/cf/customField.json";
    constructor (private http: HttpClient,
                 private readonly errorTracingService: ErrorTracingService) {}

    /*
     * get SSR Datas from json File
     */
    public getCustomField() {

        this.http.get(this.m_url)
            .subscribe((res: any) => {
                this.storeResult(res);
            },
                (error: any): void => {
                    this.errorTracingService.captureException(error);
                }
            );
    }

    /*
     * store results after getSSRList()
     */
    private storeResult(res: any) {
        this.response.data=res;
    }
  }
